import fanglaoLogoBlack from "@/assets/fanglao-logo-black.png";
import performLogo from "@/assets/perform-logo.png";

/** Stable keys stored in DB (e.g. performance_event_categories.logo_storage_key). */
export const BUNDLED_IMAGE_KEYS = {
  "assets/perform-logo.png": performLogo,
  "assets/fanglao-logo-black.png": fanglaoLogoBlack,
} as const;

export type BundledImageKey = keyof typeof BUNDLED_IMAGE_KEYS;

export function isBundledImageKey(value: string): value is BundledImageKey {
  return value in BUNDLED_IMAGE_KEYS;
}

export function resolveBundledImageSrc(key: string): string | null {
  if (!isBundledImageKey(key)) return null;
  return BUNDLED_IMAGE_KEYS[key];
}
